import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme, { styles } = {}) => ({
  drawer: { minWidth: 268 },
  root: {
    minWidth: 268,
    width: '71vw',
    maxWidth: 550,
    ...styles,
  },
  content: {
    height: '100%',
    padding: `${theme.spacing(8)} ${theme.spacing(4)} ${theme.spacing(4)}`,
    [theme.breakpoints.down('md')]: {
      padding: `${theme.spacing(5)} ${theme.spacing(1.5)} ${theme.spacing(2)}`,
    },
  },
  modal: {
    backgroundColor: 'rgba(48, 85, 107, 0.2)',
  },
  closeButton: {
    [theme.breakpoints.down('md')]: {
      right: theme.spacing(2.5),
      top: theme.spacing(2.5),
    },
  },
}));
